import LockUnlockedIcon from '@atlaskit/icon/core/lock-unlocked';
import React from 'react';

export function SvgLockUnlocked() {
  return <LockUnlockedIcon label="" testId="ads-refreshed-icon" />;
}
